import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addNumberOfItemsDueCard(ctx: DashboardCardContext) {
  const { view, getCardCopy } = ctx;

  const numberOfItemsDueComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfItemsDueComponent",
      title: "",
      description: "",
      labels: ["#ofItemsDue"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfItemsDueComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfItemsDueComponent",
      labels: ["#ofItemsDue"],
      description: getCardCopy(language, "dueItems").description,
      title: getCardCopy(language, "dueItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfItemsDueComponent.mapState(({ dashboard, language }) => {
    return {
      title: getCardCopy(language, "dueItems").title,
      number: dashboard?._calculated?.numberOfOverdueSubEntities ?? 0,
    };
  });

  numberOfItemsDueComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "endDate", "itemBasic")
  );
}
